import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { publishersInvite } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useInvitePublisher = (
  options: UseMutationOptions<void, unknown, { id: number }, unknown> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) =>
      extractData(
        publishersInvite({
          body: {
            publishers: [id],
          },
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['publishers', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
